export default __webpack_public_path__ + "static/media/order-confirmation.0059a482.png";